$(document).ready(function() {
    function location_info_update() {
        const loc = $('#location_info_select').val();
        $('.all-location-info > div').hide();

        // Reload the map IFrame
        $('#location_info_' + loc + ' iframe')
            .attr('src', function(i, val) {
                return val;
            });

        $('#location_info_' + loc).show();
    }
    $('#location_info_select').trigger('change');
    $('.all-location-info > div').hide();
    $('#location_info_select').change(location_info_update);
    location_info_update();
});
